import { DirectiveOptions,  DirectiveFunction} from 'vue/types/umd';
export const AbcClickOutside: {[key: string]: DirectiveFunction | DirectiveOptions}  = {
    bind: function (el, binding, vnode) {
        // eslint-disable-next-line
        // @ts-ignore
        el.clickOutsideEvent = function (event: Event) {
            if (!(el == event.target || (event.target && el.contains(event.target as Node)))) {
                // eslint-disable-next-line
                // @ts-ignore
                vnode?.context?.[binding.expression](event);
            }
        };
        // eslint-disable-next-line
        // @ts-ignore
        document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function (el) {
        // eslint-disable-next-line
        // @ts-ignore
        document.body.removeEventListener('click', el.clickOutsideEvent)
    },
}
